import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_URL } from '../apiConfig';

const UnsubscribePage = () => {
    const { token } = useParams();
    const [status, setStatus] = useState('loading');
    const [data, setData] = useState({});

    useEffect(() => {
        const unsubscribe = async () => {
            try {
                const response = await fetch(`${API_URL}/api/unsubscribe/${token}`);
                const result = await response.json();

                if (response.ok) {
                    setStatus('success');
                    setData(result);
                } else {
                    setStatus('error');
                    setData(result);
                }
            } catch (error) {
                setStatus('error');
                setData({ message: 'Failed to unsubscribe' });
            }
        };

        unsubscribe();
    }, [token]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-pink-200 via-purple-200 to-blue-200 p-8 flex items-center justify-center">
            <div className="max-w-md w-full bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-8 text-center">
                {status === 'loading' && (
                    <>
                        <div className="text-6xl mb-4">⏳</div>
                        <h1 className="text-3xl font-bold text-purple-600 mb-4">
                            Unsubscribing...
                        </h1>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <div className="text-6xl mb-4">👋</div>
                        <h1 className="text-3xl font-bold text-purple-600 mb-4 font-cookie">
                            You've Been Unsubscribed
                        </h1>
                        <p className="text-lg text-purple-700 mb-4">
                            {data.message}
                        </p>
                        <p className="text-sm text-gray-600">
                            Your data will be deleted within a few days. Thanks for being part of the community! 💖
                        </p>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <div className="text-6xl mb-4">😕</div>
                        <h1 className="text-3xl font-bold text-red-600 mb-4">
                            Oops!
                        </h1>
                        <p className="text-lg text-gray-700">
                            {data.detail || data.message}
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

export default UnsubscribePage;
